import { render, staticRenderFns } from "./AppCampaignIcons.vue?vue&type=template&id=bf9b12a2&"
import script from "./AppCampaignIcons.vue?vue&type=script&lang=js&"
export * from "./AppCampaignIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconSnoozeExclusive: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconSnoozeExclusive.vue').default,SvgIconInStockAndReady: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconInStockAndReady.vue').default,SvgIconCustomisable: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCustomisable.vue').default,SvgIconDeliveryVan: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconDeliveryVan.vue').default})
